import React from 'react';
import styled, { css } from 'styled-components';
import { useGalleryMenuContext } from './GalleryMenuProvider';
import { Image } from '@spotify-internal/encore-web';
const Crossfade = css `
  visibility: ${({ active }) => (active ? 'visible' : 'hidden')};
  opacity: ${({ active }) => (active ? 1 : 0)};
  z-index: ${({ active }) => (active ? 1 : 'unset')};
  transition: visibility 0.35s, opacity 0.35s ease-in-out, z-index 0s 0.35s;
`;
const ImageWrapper = styled(Image) `
  aspect-ratio: 16 / 9;
  overflow: hidden;
  max-width: 100%;
  position: absolute;
  object-fit: cover;
  ${Crossfade}
`;
export const ActiveLinkImage = ({ className }) => {
    const { activeGalleryLink, allLinks } = useGalleryMenuContext();
    return (React.createElement("div", { className: className, style: {
            position: 'relative',
            aspectRatio: '16 / 9',
        } }, allLinks === null || allLinks === void 0 ? void 0 : allLinks.map((link, idx) => {
        var _a, _b, _c, _d, _e, _f;
        return (React.createElement(ImageWrapper, { src: (_b = (_a = link === null || link === void 0 ? void 0 : link.image) === null || _a === void 0 ? void 0 : _a.file) === null || _b === void 0 ? void 0 : _b.url, key: idx, active: ((_d = (_c = link === null || link === void 0 ? void 0 : link.image) === null || _c === void 0 ? void 0 : _c.file) === null || _d === void 0 ? void 0 : _d.url) === ((_f = (_e = activeGalleryLink === null || activeGalleryLink === void 0 ? void 0 : activeGalleryLink.image) === null || _e === void 0 ? void 0 : _e.file) === null || _f === void 0 ? void 0 : _f.url) }));
    })));
};
//# sourceMappingURL=ActiveLinkImage.js.map